import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {  Grid, Label  } from "semantic-ui-react";
import { AddBtn } from "../../../../commonComponents/AddBtn";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import InputField from "../../../../commonComponents/formComponents/inputField";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../../TranslateContext";

const displayError=(value)=>{
  return(
    <PopUpIcon style={{"display": "inline"}}
          color="red" icon="exclamation triangle circle"
          popupText={<div className="error">* {value}</div>} />
  )
}
const TransitMode=({
  title,
  modeType,
  dataSource,
  validationMsg,
  errorInfo={},
  disableFields={},
  hideFields={},
  disableForm,
  saveData,
  onUpdate,
  onMotChange,
  validateError,
  fieldPattern,
  validationKey=`transportation.${modeType}.typeId`
})=>{
  
  const headerMOTList=useSelector((state) => state.DropDownValues.headerMOT);
  const headerMOTTypesList = useSelector((state) => state.DropDownValues.headerMOTTypes);
  const MOTNationalityList=useSelector((state) => state.DropDownValues.MOTNationalities);
  const {mot,type,typeId,nationality,description,transportId}=dataSource
  const translate = React.useContext(TranslateContext).translate

  
  const filteredMotType=useMemo(()=>(headerMOTTypesList.filter(c=>c.type?.split(',').includes(mot))),[mot,headerMOTTypesList])
 
  const validateTypeId=(params)=>validateError({[`${validationKey}`]:""},{transportation:{[`${modeType}`]:{typeId}}},{[`${validationKey}`]:fieldPattern(params).header[validationKey]})
  const displayWarning=()=>{
    return(
      <label style={{marginTop:"0px"}} className="label-address">
      {
       validationMsg && <PopUpIcon  icon="info circle" popupText={validationMsg}/>
     }
      {translate(title, {ns:["default", "header"]})}
      </label>
    )
  }
  if(!transportId)
    return (
      <Grid.Row>
      {displayWarning()}
     <Grid.Column width={16}  className="row mg-t-15 mg-bottom"> 
    <AddBtn id={`add-${modeType}`} onClick={()=>saveData({modeType })} text='Add'></AddBtn>
    </Grid.Column>
    </Grid.Row>
    )
 return (
     <React.Fragment>
    <Grid.Row className="theme-textbox border-b-0">
     {displayWarning()}
    <Grid.Column width="4"  className="row">  
      <Label className="title">  
      {errorInfo?.mot && displayError(errorInfo.mot)}
        MOT
      </Label>
      <DropDown
                 id={`${modeType}-mot`}
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={headerMOTList}
                disabled={disableFields?.mot || disableForm}
                value={mot}
                clearable
                onChange={(value)=>{
                  onMotChange({value,modeType,transportId})
                  validateError && validateTypeId({mot:value?.trim()})
                }
                
                }
                        />
      
    </Grid.Column>
   
    {
     !hideFields.type && <Grid.Column  className="row" width="4" >
    <Label className="title">TYPE</Label>
    <DropDown
                 id={`${modeType}-type`}
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={filteredMotType}
                disabled={disableFields?.type || disableForm}
                value={type}
                onChange={(value)=>{
                  onUpdate({type:value?.trim(),modeType,transportId})
                  saveData({type:value,modeType,transportId})
                }}
                displayType={false}
              
        />
  
    </Grid.Column>
}
     <Grid.Column  className="row" width="4" >
    <Label className="title">
    {
        errorInfo?.typeId && displayError(errorInfo.typeId)
      }
      {translate("TYPE_ID", {ns:["default", "header"]})}
      </Label>
    <InputField
        isLabel={false}
        isFooterLabel={true}
        id={`${modeType}-typeId`}
        name="typeId"
        type="text"
        clearInput={false}
        extraParams={mot}
        disabled={disableFields?.typeId || disableForm}
        onChange={(value)=>onUpdate({"typeId":value,modeType,transportId})}
        onBlur={(value) =>{
          saveData({typeId:typeId?.trim() || " ",modeType,transportId})
          validateError && validateTypeId({mot})
        }}
        value={typeId}
        
      />
    </Grid.Column>

    {
      !hideFields.nationality && <Grid.Column  className="row" width="4" >
    <Label className="title">
  
      {
        errorInfo?.nationality && displayError(errorInfo.nationality)
        }
      {translate("NATIONALITY", {ns:["default", "header"]})}
      </Label>
    <DropDown
                 id={`${modeType}-nationality`}
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                direction="left"
                data={MOTNationalityList}
                disabled={disableFields?.nationality || disableForm}
                value={nationality}
                onChange={(value)=>{
                  onUpdate({nationality:value?.trim(),modeType,transportId})
                  saveData({nationality:value,modeType,transportId})
                }}
          
        />
    
    </Grid.Column>
}
  </Grid.Row>
  
      <Grid.Row className="theme-textbox">
      {
      !hideFields.transportId &&  <Grid.Column  className="row" width="16" >
             <Label className="title">{translate("Transport ID", {ns:["default", "header"]})}</Label>
             <InputField
                  isLabel={false}
                  isFooterLabel={true}
                  id={`${modeType}-transportId`}
                  name="transportId"
                  type="text"
                  clearInput={false}
                  disabled={disableForm}
                  onChange={(value)=>onUpdate({"description":value,modeType,transportId})}
                  onBlur={(value) =>saveData({description,modeType,transportId})}
                  value={description}
                />
              </Grid.Column>
}
              </Grid.Row>

  </React.Fragment>
  );
}

export default React.memo(TransitMode)
